import {useState} from 'react';

import amplitudeDeviceTracking from '@/services/analytics/amplitude/amplitudeDeviceTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import productHelpers from '@/services/product/productHelpers';
import productService from '@/services/product/productService';

const useDeviceUnregistration = ({devices, onClose}) => {
    const [deviceIndex, setDeviceIndex] = useState(null);
    const isPopupOpened = deviceIndex !== null;
    const popupDeviceName = deviceIndex !== null ? productHelpers.getProductName(devices[deviceIndex]) : null;

    const handleUnregisterClick = (e, i) => {
        e.stopPropagation(); // stop propagation to the outer select device button
        setDeviceIndex(i);
    };

    const unregisterDevice = async (device) => {
        const {deviceSerialNumber, type, holder} = device;
        const result = await productService.unregisterConsumerProduct(device);
        // isChargerUnregistered/isHolderUnregistered can be true/false/undefined so explicit checks below are required
        const {isChargerUnregistered, isHolderUnregistered} = result || {};

        if (isChargerUnregistered === true || isChargerUnregistered === false) {
            amplitudeDeviceTracking.trackUnregisterDeviceClick(deviceSerialNumber, type, isChargerUnregistered);
            googleAnalyticsService.trackUnregisterDeviceClick(deviceSerialNumber, type, isChargerUnregistered);
        }

        if (isHolderUnregistered === true || isHolderUnregistered === false) {
            amplitudeDeviceTracking.trackUnregisterHolderClick(
                holder?.deviceSerialNumber,
                holder?.type,
                isHolderUnregistered
            );
            googleAnalyticsService.trackUnregisterDeviceClick(
                holder?.deviceSerialNumber,
                holder?.type,
                isHolderUnregistered
            );
        }
    };

    const handlePopupUnregisterClick = async () => {
        setDeviceIndex(null);
        onClose?.();
        await unregisterDevice(devices[deviceIndex]);
    };

    const handlePopupCancelClick = () => setDeviceIndex(null);

    return {isPopupOpened, popupDeviceName, handleUnregisterClick, handlePopupUnregisterClick, handlePopupCancelClick};
};

export default useDeviceUnregistration;
